import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import './Summary.css';

const Summary = ({ isOpen, toggleSidebar, handleLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [scores, setScores] = useState([]);

  useEffect(() => {
    const fetchScores = async () => {
      try {
        const response = await fetch('https://your-api-endpoint.com/scores'); // Ganti dengan endpoint API Anda
        const data = await response.json();
        setScores(data);
      } catch (error) {
        console.error('Error fetching scores:', error);
      }
    };

    fetchScores();
  }, []);

  if (!location.state) {
    navigate('/Dashboard');
  }

  return (
    <div className="dashboard">
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />

      <div className={`main-content ${isOpen ? 'expanded' : ''}`}>
        <div className="summary-page">
          <div className="summary-content">
            <h2 className="summary-title">Summary</h2>
            
            {/* Table for Scores */}
            <table className="score-table">
              <thead>
                <tr>
                  <th>Nama</th>
                  <th>Kategori</th>
                  <th>Skor</th>
                </tr>
              </thead>
              <tbody>
                {scores.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.category}</td>
                    <td>{item.score} / 50</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
